module.exports = __webpack_public_path__ + "static/media/5g_website_logo_diamond_siemens.e1e0f1b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/5g_website_logo_diamond_siemens.jpg
// module id = 91
// module chunks = 0